import React, { Component } from 'react';

import api from 'core/utils/api';
import EmployeeExposureList from './EmployeeExposureList';
import EmployeeExposureForm from './EmployeeExposureForm';

class EmployeeExposureContainer extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {
      employees: [],
      loading: false,
    };
  }

  handleSubmit(values, setSubmitting) {
    this.setState({ loading: true });

    api.post('/employee_exposure_reports', { report: values })
      .then(({ data: { report } }) => {
        this.setState({
          employees: report,
          loading: false,
        });
        setSubmitting(false);
      });
  }

  render() {
    const { employees, loading } = this.state;

    return (
      <div>
        <EmployeeExposureForm onSubmit={this.handleSubmit} />
        <EmployeeExposureList
          employees={employees}
          loading={loading}
        />
      </div>
    );
  }
}

export default EmployeeExposureContainer;



// WEBPACK FOOTER //
// ./src/features/reports/employee-exposure/EmployeeExposureContainer.js